import { validateInputTypeNumberRegex } from "./regex";

class Helper {
  public static roundTo2(num: number): string {
    if (typeof num === "number") {
      return num.toFixed(2);
    } else {
      return "0";
    }
  }

  public static formatPower(powerInWatts = 0): {
    value: number;
    unit: string;
  } {
    const watt = Number(powerInWatts ?? 0);
    if (watt < 1000) {
      return {
        value: Number(Helper.roundTo2(watt)),
        unit: "W",
      };
    }
    return {
      value: Number(Helper.roundTo2(watt / 1000)),
      unit: "kW",
    };
  }

  public static validateInputTypeNumber(
    event: React.KeyboardEvent<HTMLInputElement>,
  ) {
    const regex = validateInputTypeNumberRegex;
    const key = event.key;
    if (!regex.test(key) && event.keyCode !== 8) {
      event.preventDefault();
      return;
    }
  }
}

export default Helper;
